import styled from "@emotion/styled"
import tw from "twin.macro"

const styles = {
  width: {
    full: tw`max-w-full`,
    xl: tw`max-w-xl mx-auto px-2-4 sm:px-3-2 lg:px-7-2`,
    lg: tw`max-w-120 mx-auto px-2-4 sm:px-3-2 lg:px-7-2`,
    md: tw`max-w-100 mx-auto px-2-4 sm:px-3-2 lg:px-7-2`,
    sm: tw`max-w-77 mx-auto px-2-4 sm:px-3-2`,
    xs: tw`max-w-60 mx-auto px-2-4 sm:px-3-2`,
  },
  background: {
    light: tw`bg-light`,
    lightest: tw`bg-lightest`,
    beige: tw`bg-beige`,
    punch: tw`bg-punch`,
    yellow: tw`bg-yellow`,
    transparent: tw`bg-transparent`,
    latte: tw`bg-latte`,
  },
}

export const BackgroundContainer = styled.section<BackgroundContainerProps>`
  ${tw`w-full`}
  ${({ background }) => (background && styles.background[background] ? styles.background[background] : null)}
`

export const StyledContainer = styled.div<StyledContainerProps>`
  ${tw`w-full`}
  ${({ width }) => (width ? styles.width[width] : null)}
`

type BackgroundContainerProps = {
  background?: "light" | "lightest" | "beige" | "punch" | "yellow" | "transparent"
}

type StyledContainerProps = {
  width?: "full" | "xl" | "lg" | "md" | "sm" | "xs"
}
